const NOT_SAFE_FOR_META_PARAMS = [
  "lat",
  "lng",
  "swLat",
  "swLng",
  "neLat",
  "neLng",
];

export function pageview() {
  if (typeof (window as any).fbq === "undefined") {
    console.warn("Failed to track pageview: fbq is undefined");
    return;
  }

  const original = window.location.href;
  const url = new URL(original);
  for (const param of NOT_SAFE_FOR_META_PARAMS) {
    url.searchParams.delete(param);
  }

  window.history.replaceState(window.history.state, "", url.toString());
  (window as any).fbq("track", "PageView");
  window.history.replaceState(window.history.state, "", original);
}

// https://developers.facebook.com/docs/facebook-pixel/advanced/
export function event(
  name: string,
  options: Record<string, unknown> = {},
  eventData: { eventID?: string } = {},
): boolean {
  if (typeof (window as any).fbq === "undefined") {
    console.warn(`Failed to track event ${name}: fbq is undefined`);
    return false;
  }

  if (eventData.eventID) {
    (window as any).fbq("track", name, options, { eventID: eventData.eventID });
    return true;
  }

  (window as any).fbq("track", name, options);
  return true;
}

export function getMetaClickIds() {
  if (typeof document === "undefined") {
    return { fbc: undefined as string | undefined, fbp: undefined as string | undefined };
  }

  const cookies = Object.fromEntries(
    document.cookie.split(";").map((part) => {
      const [key, ...rest] = part.trim().split("=");
      return [key, decodeURIComponent(rest.join("="))];
    }),
  );

  return {
    fbc: cookies._fbc as string | undefined,
    fbp: cookies._fbp as string | undefined,
  };
}
